<script lang="ts">
  import type { NavItem } from "$lib/gql/genCms/codegen";
  import Typography from "$lib/components/Typography/Typography.svelte";
  import Link from "$lib/components/Link/Link.svelte";
  import NavMenuOverlay from "../NavMenuOverlay/NavMenuOverlay.svelte";
  import { createEventDispatcher } from "svelte";

  export let navItem: NavItem;
  export let shrink = false;
  export let dark = false;

  let menuHover = false;
  let span = false;

  const dispatch = createEventDispatcher();

  $: theme = navItem.highlighted
    ? "brand3"
    : navItem.open && dark
      ? "on-surface"
      : dark
        ? "on-surface"
        : "surface";
  $: hoverTheme =
    navItem.open && navItem.highlighted
      ? "brand3"
      : navItem.open && dark
        ? "on-surface-30"
        : dark
          ? "on-surface-30"
          : "surface";

  const openMenu = () => {
    dispatch("onMouseExitNav");
    setTimeout(() => {
      navItem.open = true;
    }, 0);
  };

  const closeMenu = () => {
    navItem.open = false;
  };
</script>

<style lang="scss">
  .nav-menu-item {
    /* Fixes the hover-zone issue that hides the menu-overlay,
      instead of using a setTimeout function */
    transition:
      margin 250ms ease-in-out,
      padding 250ms ease-in-out;

    &--default {
      cursor: pointer;
    }

    &--non-link {
      display: flex;
      align-items: center;
      cursor: default;
    }

    &--shrink {
      &__span {
        margin-top: 33.96px;
        padding: 0 24px 33.96px 0;
      }
    }

    &__span {
      margin-top: 49.15px;
      padding: 0 24px 49.15px 0;
    }

    &--shrink {
      &__wrapped {
        margin: 33.96px 0;
        padding-right: 24px;
      }
    }

    &__wrapped {
      margin: 49.15px 0px;
      padding-right: 24px;
    }
  }
</style>

{#if navItem && !navItem.hidden}
  <!-- svelte-ignore a11y-no-static-element-interactions -->
  <div
    on:mouseenter={() => {
      openMenu();
      span = true;
    }}
    on:mouseleave={() => {
      span = false;
    }}
    class={`nav-menu-item ${
      span
        ? shrink
          ? "nav-menu-item--shrink__span"
          : "nav-menu-item__span"
        : shrink
          ? "nav-menu-item--shrink__wrapped"
          : "nav-menu-item__wrapped"
    }`}
  >
    {#if navItem.fullPath !== null}
      <div
        on:click={closeMenu}
        on:keydown={closeMenu}
        class="nav-menu-item--default"
      >
        <Link
          {theme}
          {hoverTheme}
          text={navItem.title}
          href={navItem.fullPath}
          underline={false}
          aria-expanded={navItem.open}
          role="menuitem"
          aria-haspopup="true"
        />
      </div>
    {:else}
      <div
        class="nav-menu-item--non-link"
        role="menuitem"
        aria-expanded={navItem.open}
        aria-haspopup="true"
      >
        <Typography {theme} {hoverTheme} component="span" variant="button1">
          {navItem.title}
        </Typography>
      </div>
    {/if}
    <NavMenuOverlay
      menuOverlayOpen={navItem.open}
      navItems={navItem.items}
      {dark}
      on:hover={event => (menuHover = event.detail)}
      on:selectItem={closeMenu}
    />
  </div>
{/if}
